// Lightweight, zero-dependency token estimate used for the pre-send inspector
// and per-stage savings reports. Deliberately cheap (no WASM tokenizer load)
// since it runs on every keystroke-adjacent pipeline pass; the session
// dashboard reconciles it against the real `usage` counts the API returns.
//
// Calibrated against Claude's tokenizer behavior: code and prose average
// roughly 3.5-4 characters/token, with a per-token floor for punctuation-heavy
// text (lots of short symbols) so estimates don't collapse to near-zero on
// symbol-dense code.
export function estimateTokens(text: string): number {
  if (!text) return 0;
  const chars = text.length;
  const words = text.split(/\s+/).filter(Boolean).length;
  const byChars = chars / 3.8;
  const byWords = words * 1.3; // most words are 1-2 tokens; code identifiers skew slightly higher
  return Math.max(1, Math.ceil((byChars + byWords) / 2));
}
